module.exports = __webpack_public_path__ + "img/image-transform.e332a55d.jpg";